import Tooltip from '@mui/material/Tooltip'
import {
    ToolbarButton,
} from '@mui/x-data-grid-pro'
import useClearSorting
    from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/hooks/useClearSorting'
import ClearSortingIcon from '../ClearSortingIcon'

export default function SkyBaseClearSortingButton() {
    const handleClearSorting = useClearSorting()

    return (
        <Tooltip title="Clear Sorting">
            <ToolbarButton
                onClick={handleClearSorting}
                data-testid="clear-sorting-btn"
            >
                <ClearSortingIcon />
            </ToolbarButton>
        </Tooltip>
    )
}
